/**
 * Punkt 115 (Paket 1 „Nie mehr ins Leere“): eine Seite oeffnet die ⌘K-Suche (`ui/GlobalSearch.tsx`)
 * mit Startbegriff, z. B. „In allen Bereichen suchen“ aus einer leeren Liste. `AppShell` lauscht.
 */
export const GLOBALE_SUCHE_EREIGNIS = "maestro:globale-suche";

export function oeffneGlobaleSuche(begriff = ""): void {
  window.dispatchEvent(new CustomEvent<string>(GLOBALE_SUCHE_EREIGNIS, { detail: begriff }));
}
